import {Deserializable} from "./deserializable.model";

export class SystemLogTypeBenchmark {

   log_type_id?: number;
   log_type_benchmark_id?: number;
   log_type_benchmark_name?: string;
   log_type_benchmark_description?: string;

    is_active?: number;
    user_level?: number;
    brand_type_id?: number;
    unit_per_day?: number;
    unit_dollar_cost?: number;
    unit_dollar_value?: number;
    unit_time_duration_ms?: number;
    unit_per_day_tolerance_percentage?: number;
 
    //extra Display Filds
    log_type_benchmark_colour?: any;
    log_type_benchmark_icon?: any;


/*
log_type_benchmark_id
  log_type_id
  user_level
  brand_type_id
  unit_per_day
  log_type_benchmark_name
  log_type_benchmark_description
  is_active
  log_type_benchmark_icon
  log_type_benchmark_colour
  unit_dollar_cost
  unit_dollar_value
  unit_time_duration_ms
  unit_per_day_tolerance_percentage
*/


  // ? what does this really do? (no encoding or deserialisation required...)
//   deserialize(input: any): SystemLogTypeBenchmark {
//     Object.assign(this, input);

//     return this;
//   }


}
